import { applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import { routerMiddleware } from 'react-router-redux';
import { hashHistory } from 'react-router';

import { apiMiddleware } from 'redux-api-middleware';

import createSagaMiddleware from 'redux-saga';
export const sagaMiddleware = createSagaMiddleware();

const middleware = compose(
  applyMiddleware(
    apiMiddleware,
    thunk,
    routerMiddleware(hashHistory),
    sagaMiddleware
  )
  //Deprecated: https://github.com/zalmoxisus/redux-devtools-extension/issues/220
  //window.devToolsExtension ? window.devToolsExtension() : devTools => devTools
);

export default middleware;



// WEBPACK FOOTER //
// ./src/core/middlewares.js